var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',[_c('div',{staticClass:"wrap"},[_c('p',[_vm._v("主办单位：中宁工业园区管理委员会 "),_c('span',[_vm._v("|")]),_vm._v(" 联系电话：0955 - 5682477")]),_c('p',[_vm._v("单位地址：宁夏回族自治区中卫市中宁县宏岩矿业旁")]),_c('p',[_c('a',{attrs:{"href":"https://beian.miit.gov.cn","target":"_blank"}},[_vm._v("宁ICP备 2023001090 号")])])])])
}]

export { render, staticRenderFns }